var map = {
	"./cate-1.png": "e82c",
	"./cate-2.png": "5269",
	"./cate-3.png": "170a",
	"./cate-4.png": "7cb6",
	"./cate-5.png": "59b4",
	"./cate-6.png": "3998"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a49";